import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router-dom'

export function useUnsavedGuard({ dirty, onSave, onDiscard }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname)

  useEffect(() => {
    if (blocker.state === 'blocked') setOpen(true)
  }, [blocker.state])

  useEffect(() => {
    if (!dirty) return undefined
    const onBeforeUnload = e => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [dirty])

  const blocked = () => blocker.state === 'blocked'
  return {
    open,
    saving,
    keepEditing: () => {
      setOpen(false)
      if (blocked()) blocker.reset()
    },
    discard: () => {
      setOpen(false)
      onDiscard()
      if (blocked()) setTimeout(() => blocker.proceed(), 0)
    },
    saveAndLeave: async () => {
      setSaving(true)
      const ok = await onSave()
      setSaving(false)
      setOpen(false)
      if (ok && blocked()) setTimeout(() => blocker.proceed(), 0)
      else if (blocked()) blocker.reset()
    }
  }
}
